import { useGetTodosQuery } from "../features/api/apiSlice";
import Todo from "./Todo";
import Loader from "./ui/loaders/Loader";

export default function Todos() {
    const {data: todos, isLoading, isError} = useGetTodosQuery();

    // decide what to render 
    let content = null;

    if(isLoading){
        content = <Loader />
    }

    if( !isLoading && isError ) {
        content = "There was an error";
    }

    if( !isLoading && !isError && todos?.length > 0){
        content = todos.map( (todo) => <Todo key={todo.id} todo={todo} />)
    }
    return (
        <div className="mt-2 text-gray-700 text-sm min-h-[300px] overflow-y-auto">   
           {content}
        </div>
    );
}